import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./features/auth/AuthContext";
import reportWebVitals from "./reportWebVitals";
import GlobalProvider from "./state/global/provider.tsx";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { ProfanityFilterProvider } from "./context/ProfanityFilterContext";
import { ModuleProvider } from "./context/ModuleContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId = process.env.REACT_APP_GOOGLEDRIVE_CLIENTID;
root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <GlobalProvider>
          <AuthProvider>
            <ModuleProvider>
              <ProfanityFilterProvider>
                <App />
              </ProfanityFilterProvider>
            </ModuleProvider>
          </AuthProvider>
        </GlobalProvider>
      </LocalizationProvider>
    </GoogleOAuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
